<!--Sử dụng VXETable -->
<template>
  <b-form @submit.prevent="submitForm">

    <div v-if="formErrorMsg" class="text-danger mb-2">{{ formErrorMsg }}</div>
    <div v-if="errorDataList.length > 0" class="text-danger listError mb-2"> 
      <p v-for="error in errorDataList" :key="error" class="mb-1">{{ error }}</p>
    </div>

    <b-alert v-if="errorList.length > 0" show variant="danger" class="mb-3">
      <h6 class="alert-heading font-weight-bold">
        <i class="fas fa-exclamation-circle mr-2"></i>
          {{$t("fileUpload",{number: errorList.length})}}
      </h6>
      <div style="max-height: 150px; overflow-y: auto;" class="mt-2">
        <ul class="pl-3 mb-0">
          <li v-for="(err, idx) in errorList" :key="idx" class="small text-dark">
            <a href="javascript:void(0)" @click="scrollToRow(err.row)" class="text-danger border-bottom-dashed">
              {{$t("rowFile")}} <strong>{{ err.row }}</strong>:    {{$t("ColumnFile")}}  [{{ err.columnName }}] - {{ err.message }}
            </a>
          </li>
        </ul>
      </div>
    </b-alert>

    <div class="excel-editor-wrapper" style="height: 500px;">
      <template>
        <b-form @submit.prevent="submitForm">
            <div class="excel-editor-wrapper" style="height: 500px;">
            <vxe-table border keep-source ref="xTable" height="500" :row-class-name="rowClassName" :data="excelData"
              :column-config="{ resizable: true }" :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
              :cell-class-name="cellClassName" @edit-closed="onEditClosed" :scroll-y="{ enabled: true, gt: 100 }"
              show-overflow="title">
              <vxe-column type="seq" width="50" title="STT" fixed="left"></vxe-column>

              <vxe-column v-for="col in excelColumns" :key="col.field" :field="col.field" :title="col.title"
                min-width="180" :edit-render="{ name: 'input' }">
              </vxe-column>
            </vxe-table>
          </div>

          <div class="text-right pt-3">
            <b-button type="button" variant="secondary" class="mr-3" @click="onClickCancel" :disabled="isSubmitting">
              {{ $t("cancel") }}
            </b-button>
            <b-button type="submit" variant="primary" :disabled="isSubmitting">
              {{ $t("confirm") }}
            </b-button>
          </div>
        </b-form>
      </template>
    </div>

    <div class="text-right pt-3">
      <b-button type="button" variant="secondary" class="mr-3" @click="onClickCancel" :disabled="isSubmitting">
        {{ $t("cancel") }}
      </b-button>
      <b-button type="submit" variant="primary" :disabled="isSubmitting">
        {{ $t("confirm") }}
      </b-button>
    </div>
  </b-form>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import BaseComponent from "@/components/BaseComponent";
import { VALIDATION_CONFIG, Patterns } from './validateConfig';

@Component
export default class PreviewFileExcel extends BaseComponent {
  @Prop({ required: true }) modalId!: string;
  @Prop({ required: true }) typeModal!: "contact" | "user" | "meeting";
  @Prop({ default: () => [] }) initialData!: any[];

  excelData: any[] = [];
  excelColumns: any[] = [];

  errorList: Array<{row: number;column: string;columnName: string; message: string;}> = [];

  formErrorMsg = "";
  errorDataList: any[] = [];
  isSubmitting = false;

  @Emit("submitted") __submitted() {}

  /* =========================
   * LIFECYCLE
   * ========================= */
  mounted() {
    if (this.initialData.length > 0) {
      const normalized = this.normalizeExcelData(this.initialData);
      this.excelData = this.mapExcelData(normalized);
      this.initColumns();
      this.checkAllErrors();
    }

    this.$nextTick(() => {
      const table = this.$refs.xTable as any;
      table && table.recalculate(true);
    });
  }

  /* =========================
   * NORMALIZE & MAP
   * ========================= */

  // Ép KEY Excel → UPPERCASE
  normalizeExcelData(data: any[]) {
    return data.map(row => {
      const newRow: any = {};
      Object.keys(row).forEach(k => {
        newRow[k.trim().toUpperCase()] = row[k];
      });
      return newRow;
    });
  }

  // Map Excel → schema chuẩn
// PreviewFileExcel.vue

mapExcelData(data: any[]) {
  const config = VALIDATION_CONFIG[this.typeModal];
  if (!config) return [];

  return data.map(row => {
    const obj: any = {};
    config.mapping.forEach(m => {
      const col = m.fields.find(f => f in row);
      
      // LOGIC MỚI:
      if (col) {
        obj[m.key] = row[col];
      } else if (m.required) {
        obj[m.key] = "";
      }
      // Optional mà không có dữ liệu thì bỏ qua luôn
    });
    return obj;
  });
}

  /* =========================
   * INIT COLUMN
   * ========================= */
// Trong PreviewFileExcel.vue

// PreviewFileExcel.vue

initColumns() {
  const config = VALIDATION_CONFIG[this.typeModal];
  if (!config) return;
  
  // Lấy dòng dữ liệu mẫu đầu tiên để kiểm tra các key tồn tại
  const firstRow = this.excelData[0] || {};

  // Lọc các cột cần hiển thị
  const activeMapping = config.mapping.filter(m => {
    // 1. Luôn hiện nếu là bắt buộc
    if (m.required) return true;
    
    // 2. Nếu là Optional, chỉ hiện khi key này có tồn tại trong dữ liệu đã map
    // (Do bước 1 & 2 đã loại bỏ key nếu không có trong file, nên ta chỉ cần check hasOwnProperty)
    return Object.prototype.hasOwnProperty.call(firstRow, m.key);
  });

  this.excelColumns = activeMapping.map(m => ({
    field: m.key,
    title: this.getColumnLabel(m),
    width: "",
    minWidth: "150"
  }));
}


  /* =========================
   * VALIDATION
   * ========================= */
  validateRow(row: any) {
    const errors: any[] = [];
    const config = VALIDATION_CONFIG[this.typeModal];
    if (!config) return errors;

    config.mapping.forEach(m => {
      const value = row[m.key];
      const label = this.getColumnLabel(m); // Lấy label hiển thị 

      if (this.typeModal === "meeting" && m.key === "phone") {
        if (value && !Patterns[m.pattern](value)) {
          errors.push({
            column: m.key,
            columnName: label,
            message: this.$t("importPhoneNotCorrect").toString()
          });
        }
        return;
      }

      if (m.required && (!value || !Patterns.text(value))) {
        errors.push({
          column: m.key,
          columnName: label,
          message: `[${label}] ` + this.$t("importNotNull")
        });
        return;
      }

      if (value && !Patterns[m.pattern](value)) {
        let msg = this.$t("importFormatCell") + ` ${m.pattern} `;
        if (m.pattern === "phone") msg = this.$t("importPhoneNotCorrect").toString();
        if (m.pattern === "email") msg = this.$t("importEmailNotCorrect").toString();

        errors.push({
          column: m.key,
          columnName: label,
          message: msg
        });
      }
    });

    return errors;
  }


  checkAllErrors() {
    this.errorList = [];
    this.excelData.forEach((row, idx) => {
      this.validateRow(row).forEach(err => {
        this.errorList.push({
          row: idx + 1,
          column: err.column,
          columnName: err.columnName,
          message: err.message
        });
      });
    });
    return this.errorList.length === 0;
  }

  /* =========================
   * VXETABLE HOOKS
   * ========================= */
  cellClassName({ row, column }: any) {
    return this.validateRow(row).some(e => e.column === column.property)
      ? "col-cell-error"
      : "";
  }

  rowClassName({ row }: any) {
    return this.validateRow(row).length ? "row-error-bg" : "";
  }

  onEditClosed({ row }: any) {
    const idx = this.excelData.indexOf(row) + 1;
    this.errorList = this.errorList.filter(e => e.row !== idx);

    this.validateRow(row).forEach(err => {
      this.errorList.push({
        row: idx,
        column: err.column,
        columnName: err.columnName,
        message: err.message
      });
    });

    this.errorList.sort((a, b) => a.row - b.row);
  }

  /* =========================
   * SUBMIT
   * ========================= */

  // Gen CODE
  generateRandomCodeID(): string {
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let textPart = "";

    // 1. Lấy ngẫu nhiên 24 chữ cái
    for (let i = 0; i < 4; i++) {
      textPart += letters.charAt(Math.floor(Math.random() * letters.length));
    }

    // 2. Lấy ngẫu nhiên 1 số từ 0-9
    const numberPart = Math.floor(Math.random() * 10);

    return `${textPart}${numberPart}`;
  }

  // 
  async submitForm() {
    this.formErrorMsg = "";

    // 1. Validate dữ liệu rỗng
    if (!this.excelData.length) {
      this.formErrorMsg = this.$t("importEmptyData").toString();
      return;
    }

    // 2. Validate lỗi logic
    if (!this.checkAllErrors()) {
      this.scrollToRow(this.errorList[0].row);
      return;
    }

    this.isSubmitting = true;
    try {

      const finalData = this.excelData.map(row => {
        const { _X_ROW_KEY, ...rowData } = row;
        const existingCode = rowData.code ? String(rowData.code).trim() : "";
        const finalCodeID = existingCode !== "" ? existingCode : this.generateRandomCodeID();
        return {
          ...rowData,
          CODE: finalCodeID
        };
      });
      this.$emit("imported", finalData);
      this.$bvModal.hide(this.modalId);

    } catch (e) {
      console.error(e);
      this.formErrorMsg = this.$t("errorReadFile").toString();
    } finally {
      this.isSubmitting = false;
    }
  }


  //
  onClickCancel() {
    this.$bvModal.hide(this.modalId);
  }

  scrollToRow(rowNumber: number) {
    const table = this.$refs.xTable as any;
    const target = this.excelData[rowNumber - 1];
    table &&
      table.scrollToRow(target).then(() => {
        table.setCurrentRow(target);
        setTimeout(() => table.clearCurrentRow(), 1000);
      });
  }

  // Get label cho hiển thị
  getColumnLabel(m: any) {
    return m.label ?? m.fields[0];
  }
}
</script>

<style scoped lang="scss">
.excel-editor-wrapper {
  border: 1px solid #dcdfe6;
}

::v-deep .vxe-body--row.row-error-bg {
  background-color: #fff2f0 !important;

  .vxe-body--column {
    color: #ff4d4f !important;
  }

  &.row--hover {
    background-color: #ffccc7 !important;
  }
}
</style>